import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  LOCALE_ID,
  importProvidersFrom,
  isDevMode,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";

import { provideState, provideStore } from "@ngrx/store";

import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
import { provideEffects } from "@ngrx/effects";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import {
  LOCALE_ID_NO_REGION,
  PRIME_NG_TRANSLATION,
} from "internalization-module";
import { AvailableLocales, LOCALE } from "shared";
import { MeetingRoomsKioskEffects } from "./+store/effects";
import { meetingRoomsKioskReducer } from "./+store/reducer";
import { kioskTokenInterceptor } from "./interceptors/kiosk-token.interceptor";
import { MessageService } from "primeng/api";

export const KIOSK_STORE_NAME = "meetingRoomsKiosk";

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, BrowserAnimationsModule),
    provideRouter(routes),
    provideHttpClient(withInterceptors([kioskTokenInterceptor])),
    provideStore({}),
    provideState({
      name: "meetingRoomsKiosk",
      reducer: meetingRoomsKioskReducer,
    }),
    provideEffects(MeetingRoomsKioskEffects),
    provideStoreDevtools({
      maxAge: 50,
      logOnly: !isDevMode(),
    }),

    // i18n providers
    {
      provide: LOCALE_ID,
      useFactory: () => {
        const validLocales = Object.values(AvailableLocales).filter(
          (value) => typeof value === "string",
        ) as string[];
        const localeCurrent = localStorage.getItem(LOCALE) || null;
        return localeCurrent && validLocales.includes(localeCurrent)
          ? localeCurrent
          : AvailableLocales.English;
      },
    },
    { provide: MAT_DATE_LOCALE, useExisting: LOCALE_ID },
    {
      provide: LOCALE_ID_NO_REGION,
      useFactory: () => {
        const validLocales = Object.values(AvailableLocales).filter(
          (value) => typeof value === "string",
        ) as string[];
        const localeCurrent = localStorage.getItem(LOCALE) || null;
        return localeCurrent && validLocales.includes(localeCurrent)
          ? localeCurrent
          : AvailableLocales.English;
      },
    },
    {
      provide: PRIME_NG_TRANSLATION,
      useFactory: () => {
        return null; // Will be set dynamically by bootstrapWithLanguage
      },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    MessageService,
  ],
};
